/* Boboné — collection card color swap.
   Hovering / clicking / focusing a color swatch on a product card swaps the
   card's featured image to that color's variant image. Reverts when the
   pointer leaves the card. Swatches that have no variant image do nothing.
   Data hooks come from snippets/bobone-product-card.liquid:
     a[data-bobone-card]  ·  .bobone-card-swatch[data-swatch-image] */
(function () {
  function wire(card) {
    if (card.dataset.swatchWired) return;
    var img = card.querySelector('.bobone-product-card__image');
    if (!img) return;
    var swatches = card.querySelectorAll('.bobone-card-swatch[data-swatch-image]');
    if (!swatches.length) return;
    card.dataset.swatchWired = '1';

    var defaultSrc = img.getAttribute('src');
    var defaultSrcset = img.getAttribute('srcset');

    function show(url) {
      img.removeAttribute('srcset'); // let src win regardless of viewport
      img.setAttribute('src', url);
    }
    function revert() {
      img.setAttribute('src', defaultSrc);
      if (defaultSrcset) img.setAttribute('srcset', defaultSrcset);
    }

    swatches.forEach(function (sw) {
      var url = sw.getAttribute('data-swatch-image');
      sw.addEventListener('mouseenter', function () { show(url); });
      sw.addEventListener('focus', function () { show(url); }, true);
      // Clicking a swatch should preview the color, not follow the card link.
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(url);
      });
    });

    card.addEventListener('mouseleave', revert);
  }

  function init(root) {
    (root || document).querySelectorAll('a[data-bobone-card]').forEach(wire);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-wire cards injected by AJAX filtering / pagination.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('bobone:cards:refresh', function (e) { init(e.target || document); });
})();
